import {
  FETCH_DELIMIT_REPORT_REQUEST,
  FETCH_DELIMIT_REPORT_SUCCESS,
  FETCH_DELIMIT_REPORT_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  list: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_DELIMIT_REPORT_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }

    case FETCH_DELIMIT_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        isFetching: false,
        list: action.payload,
      }

    case FETCH_DELIMIT_REPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
